import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { StringInputWithEventViewModel, ValueFieldType } from '../Types';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { handleOnChangeWithEvent } from '../Functions';
import { getCookieValue, GetPiwikSession, getAttributeValueFromJsonString } from 'lib/utils';
import { FormEvent } from 'lib/enum';

export const Hidden: React.FunctionComponent<ValueFieldProps<StringInputWithEventViewModel>> = (props) => {
  const router = useRouter();
  const { field, value, onChange } = props;

  const [eventTriggered, setEventTriggered] = useState(false);
  const [currentFieldValue, setCurrentFieldValue] = useState(value);

  const valueField = field.valueField as ValueFieldType;
  const { id, name } = valueField;

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    const getHiddenFieldValue = (model: StringInputWithEventViewModel) => {
      const $queryStringKey = `${model.queryString}`;
      const $eventReference = model.onChangeEventMessage;
      let $hiddenFieldValue = '';

      // Read data from query string if queryString key is provided
      if ($queryStringKey) {
        $hiddenFieldValue = `${router.query[$queryStringKey] || ''}`;
      }

      // Read data from cookie if cookieSource key is provided and query string value is not found
      if (!$hiddenFieldValue && field.model.cookieSource) {
        $hiddenFieldValue = getCookieValue(`${field.model.cookieSource || ''}`);
      }

      // Special case to load PIWIK Session ID into hidden field when event message is LoadPiwikSessionId and value is not found in query string or cookie
      if (!$hiddenFieldValue && $eventReference === FormEvent.LoadPiwikSessionId) {
        $hiddenFieldValue = GetPiwikSession() || '';
      }

      // Special case to load current page url into hidden field when event message is LoadCurrentPageUrl and value is not found in query string or cookie
      if (!$hiddenFieldValue && $eventReference === FormEvent.LoadCurrentPageUrl) {
        $hiddenFieldValue = document.location.href;
      }

      // Special case to load mcp id into hidden field when event message is LoadMCPId and value is found
      if ($hiddenFieldValue && $eventReference === FormEvent.LoadMCPId) {
        $hiddenFieldValue = getAttributeValueFromJsonString($hiddenFieldValue, 'uuid');
      }

      // Use value from props if query string and cookie do not have the value and value is provided
      if (!$hiddenFieldValue && value) {
        $hiddenFieldValue = value;
      }
      return $hiddenFieldValue;
    };

    const hiddenFieldValue = getHiddenFieldValue(field.model);
    setCurrentFieldValue(hiddenFieldValue);

    if (!eventTriggered) {
      setEventTriggered(true);
      hiddenFieldValue && handleOnChangeWithEvent(field, hiddenFieldValue, onChange);
    }
  }, [router.isReady, router.query, currentFieldValue, eventTriggered, field, name, value, onChange]);

  return <input type="hidden" id={id} name={name} value={currentFieldValue} />;
};
